import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import Button from '../Button/Button'
import useTakeBackStyle from './TakeBack.style'
import TextField from '../TextField/TextField'

type Props = {
  handleNextStep?: () => void
  parcelNumber: number
  onChange: (parcelNumber: number) => void
}

const TakeBackEditParcelNumberStep = ({
  parcelNumber,
  onChange,
  handleNextStep,
}: Props) => {
  const { t } = useTranslation()
  const classes = useTakeBackStyle()
  const [parcelNumberForm, setParcelNumberForm] = useState('')

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (!parcelNumber) {
      return
    }
    handleNextStep?.()
  }

  const handleChange = (value: string) => {
    setParcelNumberForm(value)
    onChange(parseInt(value))
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className={clsx(classes.firstStepFirstPartContainer)}>
        <div
          className={clsx(classes.marginBottom, classes.parcelNumberContainer)}
        >
          <TextField
            label={t('texts:takeBack:parcel_number_label')}
            type="number"
            value={parcelNumberForm}
            onChange={handleChange}
            required
            min={1}
          />
        </div>
        <div className={clsx(classes.center, classes.parcelNumberButton)}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            type="submit"
            className={classes.buttonNextPart}
          >
            {t('texts:takeBack:next_step_button')}
          </Button>
        </div>
      </div>
    </form>
  )
}

export default TakeBackEditParcelNumberStep
